import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Coloring Kids" />
    <h1>An app to find and print kids' coloring pages.</h1>
    <p>
      My kids love printing coloring pages on the internet. They were asking me
      to print pages all the time, and I wanted an easier way to do it. I tried
      to make it easy enough they can do it themselves from an iPad. Now they're
      able to do it without me. I just have to make sure to keep buying paper
      and ink!
    </p>
    <p>
      <Link to="/support/">Support</Link> | <Link to="/privacy/">Privacy</Link>
    </p>
  </Layout>
)

export default IndexPage
